<template>
  <pt-policy-table class="pt-policy-table__withData" :tableLabels="tableLabels" @getTableData="getTableData" :totalNumber="totalNumber"
  :tableData="tableData" ref="table" :page-size="pageSize" :isOutside="isOutside" v-loading="loading">
  <slot/>
  </pt-policy-table>
</template>

<script>
import PtPolicyTable from './index'
export default {
  name: 'pt-policy-table__withData',
  components: {
    'pt-policy-table': PtPolicyTable
  },
  computed: {
    page () {
      return this.$refs.table.page
    },
    // 是否积分政策
    isIntegralpolicy () {
      return this.$route.name === 'integral-policy-manage'
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    selectTab: {
      type: String,
      default: ''
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false,
      loading: false
    }
  },
  watch: {
    selectTab (val) {
      if (!this.isFromRouter) {
        this.$refs.table.resetPage()
      } else {
        this.isOutside = true
        this.getTableData(this.page)
      }
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        page: this.page,
        size: this.pageSize
      }
      let policyType = {}
      switch (this.selectTab) {
        case 'afterSales':policyType = this.isIntegralpolicy
          ? { apiUrl: 'getIntegralAfterSalesPolicies', name: '积分商品售后政策' } : { apiUrl: 'afterSalesPolicies', name: '售后政策' }
          break
        case 'carriage':policyType = this.isIntegralpolicy
          ? { apiUrl: 'getIntegralaCarriagePolicies', name: '积分商品运费政策' } : { apiUrl: 'getCarriagePolicies', name: '运费政策' }
          break
        case 'privacy':policyType = this.isIntegralpolicy
          ? { apiUrl: 'getIntegralPrivacyPolicies', name: '隐私政策' } : { apiUrl: 'getPrivacyPolicies', name: '隐私政策' }
          break
        default:
          console.log('尚未选择类型')
      }
      this.getPolicyList(data, next, policyType)
    },
    getPolicyList (data, next, policyType) {
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch(policyType.apiUrl, data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取' + policyType.name + '失败')
      })
    }
  }
}
</script>
